<h5>Email quota</h5>
<div>
  The account can send
  <span *ngIf="canSendEmails; else unlimited"
    ><b>{{ canSendEmails }}</b>
    <span *ngIf="canSendEmails === 1; else plural"> email</span
    ><ng-template #plural><span> emails</span></ng-template></span
  >
  <ng-template #unlimited>
    <span><b>unlimited</b> number of emails</span>
  </ng-template>
</div>
<div class="quota" [formGroup]="monthlyQuota">
  <div class="quota__form">
    <span class="label">Monthly quota</span>
    <input type="number" class="form-control" formControlName="emailQuota" />
    <div
      class="text-danger"
      *ngIf="emailQuota.invalid && (emailQuota.dirty || emailQuota.touched)"
    >
      Monthly quota is invalid
    </div>
  </div>
  <div class="quota__form">
    <span class="label">Order number *</span>
    <input
      type="text"
      class="form-control"
      maxLength="17"
      placeholder="Order number (16 alphanumeric characters)"
      formControlName="orderNumber"
    />
    <div
      class="text-danger"
      *ngIf="
        monthyQuotaOrderId.invalid &&
        (monthyQuotaOrderId.dirty || monthyQuotaOrderId.touched)
      "
    >
      <span *ngIf="monthyQuotaOrderId.hasError('required')">Required</span>
      <span *ngIf="monthyQuotaOrderId.hasError('pattern')">
        Order number is invalid. It should have 16 alphanumeric characters
      </span>
    </div>
  </div>
  <div class="quota__form">
    <app-button
      class="quota__form--button"
      bsClass="primary"
      [labeled]="true"
      [showLoader]="loadingMonthlyQuota"
      [disabled]="monthlyQuota.invalid"
      (handleClick)="addMonthlyQuota('monthly')"
    >
      Save changes
    </app-button>
  </div>
</div>
<div class="quota" [formGroup]="oneTimeQuota">
  <div class="quota__form">
    <span class="label">One-time quota upgrade</span>
    <input
      type="number"
      class="form-control"
      formControlName="emailOneTimeQuota"
    />
  </div>
  <div class="quota__form">
    <span class="label">Order number *</span>
    <input
      type="text"
      class="form-control"
      maxLength="17"
      placeholder="Order number (16 alphanumeric characters)"
      formControlName="orderNumber"
    />
    <div
      class="text-danger"
      *ngIf="
        oneTimeQuotaOrderId.invalid &&
        (oneTimeQuotaOrderId.dirty || oneTimeQuotaOrderId.touched)
      "
    >
      <span *ngIf="oneTimeQuotaOrderId.hasError('required')">Required</span>
      <span *ngIf="oneTimeQuotaOrderId.hasError('pattern')">
        Order number is invalid. It should have 16 alphanumeric characters
      </span>
    </div>
  </div>
  <div class="quota__form">
    <app-button
      class="quota__form--button"
      bsClass="primary"
      [labeled]="true"
      [showLoader]="loadingOneTimeQuota"
      [disabled]="!oneTimeQuota.valid"
      (handleClick)="addOneTimeQuota('oneTime')"
    >
      Save changes
    </app-button>
  </div>
</div>
<div *ngIf="lastDate">
  One-time quota expires at <b>{{ lastDate }}</b>
</div>
